export const orgIdSelector = (state) => state.app?.orgId;
